export interface IDexieConfigurationUpdates {
    id?: number;
    name: string;
    date: string;
}

export class DexieConfigurationUpdates implements IDexieConfigurationUpdates {
    public id?: number;
    public name: string;
    public date: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieConfigurationUpdates);
    constructor(obj?: any) {
        if (obj && obj.id) {
            this.id = obj && obj.id;
        }
        this.name = obj && obj.name || '';
        this.date = obj && obj.date || '';
    }
}
